import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Sparkles } from 'lucide-react';
export function UniqueMechanism() {
  return <SectionWrapper bgColor="forest" data-id="element-157">
      <div className="border-2 border-brand-amber/30 rounded-3xl p-8 md:p-12 bg-brand-forest relative overflow-hidden" data-id="element-158">
        {/* Decorative background element */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-amber opacity-5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-159"></div>

        <div className="relative z-10" data-id="element-160">
          <div className="flex items-center gap-3 mb-6" data-id="element-161">
            <Sparkles className="w-8 h-8 text-brand-amber" data-id="element-162" />
            <span className="text-brand-amber font-bold tracking-wider uppercase text-sm" data-id="element-163">
              El Secreto
            </span>
          </div>

          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-164">
            El Método de Sustitución de "Bio-Gatillos"
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brand-cream/90 leading-relaxed" data-id="element-165">
            <p data-id="element-166">
              Este sistema no te pide que dejes de comer rico. Te enseña a
              identificar las 5 moléculas específicas de la cocina latina que
              relajan tu válvula estomacal y cómo sustituirlas por alternativas
              que saben igual pero se digieren en la mitad del tiempo.
            </p>

            <p className="font-medium text-white text-xl md:text-2xl border-l-4 border-brand-amber pl-6 py-2 mt-8" data-id="element-167">
              Es como hacerle una "actualización de software" a tu estómago para
              que funcione con la eficiencia de hace 20 años.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}